<script setup lang="ts">
  import { computed } from 'vue';
  import type { TrainingDetail } from '@/entities/Training';
  import { formatCivilDateToPtBR } from '@/shared/lib';
  import { formatTrainingControlValue } from '../../lib/formatTrainingControlValue';

  const props = defineProps<{
    scheduling: TrainingDetail['scheduling'];
  }>();

  const scheduledDateLabel = computed(() =>
    props.scheduling.date
      ? formatCivilDateToPtBR(props.scheduling.date)
      : formatTrainingControlValue(null)
  );
</script>

<template>
  <section
    data-testid="training-control-section-programming"
    class="flex flex-col gap-4 border-b border-gray-02 px-6 py-8"
  >
    <h2 class="text-sm font-semibold text-gray-07">
      Programação Treinamento
    </h2>

    <div class="grid gap-4 md:grid-cols-3">
      <div class="flex flex-col gap-2">
        <span class="text-xs font-semibold text-gray-07">Responsável pela Programação:</span>
        <span
          data-testid="training-control-programming-responsible"
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
        >
          {{ formatTrainingControlValue(scheduling.responsible?.name) }}
        </span>
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-xs font-semibold text-gray-07">Cargo:</span>
        <span
          data-testid="training-control-programming-position"
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
        >
          {{ formatTrainingControlValue(scheduling.position?.name) }}
        </span>
      </div>
      <div class="flex flex-col gap-2">
        <span class="text-xs font-semibold text-gray-07">Data da programação:</span>
        <span
          data-testid="training-control-programming-date"
          class="rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3 text-sm text-gray-07"
        >
          {{ scheduledDateLabel }}
        </span>
      </div>
    </div>
  </section>
</template>
